export const centerBetweenTwoPoints = (
  p1: Vector3,
  p2: Vector3,
  outP: Vector3
) => outP.copy(p1).add(p2).multiplyScalar(0.5);
